export enum CustomerKeyType {
  GUEST = 'Guest',
  CUSTOMER = 'Customer',
}
